/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { Box, Grid, Typography } from '@mui/material';
import React, { useState, useCallback, useMemo } from 'react';
import { DataGridPro as DataGrid } from '@mui/x-data-grid-pro';
import { useNavigate } from 'react-router-dom';
import { debounce } from '../utils/common';
import { useSurveyList } from '../components/api/queries/hooks';
import { getSurveyTableColumns } from '../components/GridColumns';
import { QuickSearchToolbar } from '../components/QuickSearch';

export const SurveyPage = () => {
  const [displaySearchText, setDisplaySearchText] = useState('');
  const [apiSearchText, setApiSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const navigate = useNavigate();

  const { data: { data: surveyListData = [], totalRecords = 0 } = {}, isLoading } = useSurveyList({
    pageSize,
    pageNumber: currentPage + 1,
    search: apiSearchText
  });

  const debouncedSetApiSearchText = useMemo(
    () => debounce((value) => setApiSearchText(value), 500),
    []
  );

  const requestSearch = useCallback(
    (searchValue) => {
      // Update display immediately
      setDisplaySearchText(searchValue);
      // Update API search with debounce
      debouncedSetApiSearchText(searchValue);
    },
    [debouncedSetApiSearchText]
  );

  const handleRowClick = (params) => {
    const { row } = params;
    const surveyId = row.publicId || row.id;
    navigate(`/dashboard/survey-details?id=${surveyId}`);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" style={{ margin: 10 }}>
        Survey
      </Typography>

      <Grid
        item
        style={{
          flexGrow: 1,
          height: '75vh',
          width: '100%'
        }}
      >
        <DataGrid
          components={{
            Toolbar: QuickSearchToolbar
          }}
          sx={{
            '& .MuiDataGrid-row': {
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#f5f5f5'
              }
            }
          }}
          componentsProps={{
            toolbar: {
              value: displaySearchText,
              onChange: (event) => requestSearch(event.target.value),
              clearSearch: () => requestSearch('')
            }
          }}
          loading={isLoading}
          rows={surveyListData || []}
          getRowId={(row) => row.publicId}
          columns={getSurveyTableColumns()}
          pagination
          paginationMode="server"
          rowCount={totalRecords}
          rowsPerPageOptions={[5, 10, 25, 100]}
          page={currentPage}
          pageSize={pageSize}
          onPageChange={(newPage) => {
            setCurrentPage(newPage);
          }}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setCurrentPage(0);
          }}
          onRowClick={handleRowClick}
          disableSelectionOnClick
        />
      </Grid>
    </Box>
  );
};
